import { Link, Navigate } from 'react-router-dom'
//import * as _ from 'lodash'

import * as React from 'react'

import Persistence from "./Persistence"

import brandThumb from '../Components/brand/white_thumb.png'

import { Schedule, Expenses, Notes, Account, Students, Signout, Add, Menu } from "../Components/Icons"
import Modal from './Modal'
import { Button } from '../Components/Form/Button'

import MenuStudent from './MenuStudent'
import AddStudentForm from './Form/AddStudentForm'

export interface Props {
    children: React.ReactNode
}

export interface State {
    addStudent: boolean
    openMenu: boolean
}

Persistence.setValues()

export class Main extends React.Component<Props, any> {

    public constructor(props: Props) {
        super(props)

        const students = Persistence.getStudents()
        //console.log('student', students)
        let addStudent = false

        if (students.length <= 0 ) addStudent = true

        this.state = {
            addStudent,
            openMenu: false
        }

    }

    public signout = async () => {
        await Persistence.clear()

        this.setState({})
    }

    public toggleMenu = async () => {
        let menu = !this.state.openMenu
        this.setState({openMenu: menu})
    }

    public studentsMenu = () => {
        const students = Persistence.getStudents()

        let tiles = []

        tiles.push(
            <button className="flex items-center w-full px-5 py-2 transition-colors duration-200 dark:hover:bg-gray-800 gap-x-2 hover:bg-gray-800 focus:outline-none">
                <div className="object-cover w-8 h-8 rounded-full">
                    <Students 
                        size='medium'
                        className='cursor-pointer fill-gray-200 hover:fill-white mx-1'
                    />
                </div>
                <div className="text-left rtl:text-right">
                    <h1 className="text-sm font-medium text-gray-700 capitalize dark:text-white">All Students</h1>
                </div>
            </button>
        )

        for (let s of students) {
            tiles.push(<MenuStudent
                student={s}
            />)
        }

        tiles.push(
            <div>
                <button
                    onClick={() => this.toggleAddStudent()}
                    type="button"
                    className="flex items-center flex-row justify-self-center ml-3 px-4 py-2 text-sm font-medium text-gray-900 bg-gray-800 border border-gray-700 rounded-lg hover:bg-gray-100 hover:bg-gray-700 focus:z-10 focus:ring-2 focus:focus:ring-blue-500 focus:text-white dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <Add 
                        size='medium'/>
                    Add Student
                </button>
            </div>
        )

        return tiles
    }

    public toggleAddStudent = () => {
        this.setState({ addStudent: !this.state.addStudent })
    }

    public getAddStudentForm = () => {

        return (<AddStudentForm
            closeForm={this.toggleAddStudent}
            processForm={(data) => console.log(data)}
            form={{}}
            errors={{}}
        />
        )
    }

    public render(): React.ReactNode {
        const user: number = Persistence.getUserId()
        let iconClass = 'cursor-pointer fill-gray-200 hover:fill-white mx-1'

        if (user <= 0) {
            // user is not authenticated
            return <Navigate to="/login" />;
        }

        let menuVisibility = this.state.openMenu ? 'flex' : 'hidden'
        let mainMargin = this.state.openMenu ? 'ml-72' : 'ml-0'

        return (
            <div>
                <Modal
                    open={this.state.addStudent}
                    onClose={this.toggleAddStudent}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    {this.getAddStudentForm()}
                </Modal>
                <aside className={`flex fixed top-0 left-0 ${menuVisibility} sm:flex z-10`}>
                    <div className="flex flex-col items-center w-16 h-screen py-8 space-y-8 bg-gray-900 dark:bg-gray-900 dark:border-gray-700">
                        <Link to="/schedule">
                            <img src={brandThumb} className='w-8 object-cover' alt="Homeschool and Daily Activity Tracker"/>
                        </Link>

                        {/*<Link to="/dashboard" title='Dashboard' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Home
                            size='large' 
                            className={iconClass}/>
                        </Link>*/}

                        <Link to="/schedule" title='Schedule' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Schedule  
                            size='large' 
                            className={iconClass} />
                        </Link>

                        <Link to="/expenses" title='Expenses' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Expenses 
                            size='large' 
                            className={iconClass}/>
                        </Link>

                        <Link to="/notes" title='Progress' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Notes 
                            size='large' 
                            className={iconClass}/>
                        </Link>

                        <Link to="/account" title='Account' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Account 
                            size='large' 
                            className={iconClass}/>
                        </Link>

                        <Button type='button' onClick={this.signout} title='Signout' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                            <Signout 
                            size='large' 
                            className={iconClass}
                            />
                        </Button>
                    </div>

                    <div className="h-screen py-8 overflow-y-auto bg-white border-l border-r sm:w-64 w-60 dark:bg-gray-900 dark:border-gray-700">
                        <h2 className="px-5 text-lg font-medium text-gray-800 dark:text-white">Students</h2>

                        <div className="mt-8 space-y-4">
                            {this.studentsMenu()}
                        </div>
                    </div>
                </aside>
                <div className={`p-4 ${mainMargin} md:ml-72`}>
                    <div className='h-5 flex md:hidden w-full flex-row p-1'>
                        <div className='flex-none'>
                            <Button type='button' onClick={this.toggleMenu} title='Open Menu' className="text-white focus:outline-nones rounded-lg text-white hover:bg-transparent">
                                <Menu
                                size='large' 
                                className='cursor-pointer fill-gray-800 hover:fill-gray-600 mx-1' />
                            </Button>    
                        </div>
                        <div className='flex-grow'></div>
                        </div>
                    <div>
                            {this.props.children}
                    </div>
                </div>
            </div>
        )
    }

}

export default Main